export default function dispatchEvent(node, type, options = {}) {
  const event = new Event(type, { bubbles: true, cancelable: true, ...options });
  node.dispatchEvent(event);
}
